import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { loginUrl } from '../../constants/url-constants';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(
    private http: HttpClient,
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService
  ) {}

  getToken() {
    return (
      this.$localStorage.retrieve('authenticationToken') ||
      this.$sessionStorage.retrieve('authenticationToken')
    );
  }

  login(credentials): Observable<any> {
    const data = {
      username: credentials.username,
      password: credentials.password,
      rememberMe: credentials.rememberMe,
      appType: credentials.appType,
      clientName: credentials.clientName,
    };
    return this.http
      .post(loginUrl, data, { observe: 'response' })
      .pipe(map(authenticateSuccess.bind(this)));

    function authenticateSuccess(resp) {
      const bearerToken = resp.headers.get('Authorization');
      if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
        const jwt = bearerToken.slice(7, bearerToken.length);
        if (jwt == 'null') {
          throw throwError(() => 'invalid Credentials');
        }
        this.storeAuthenticationToken(jwt, credentials.rememberMe);
        this.$sessionStorage.store(
          'redirectToResetPassword',
          resp.body.passwordResetFlag
        );
        return jwt;
      }
    }
  }

  getUserRedirection() {
    return this.$sessionStorage.retrieve('redirectToResetPassword');
  }

  resetRedirectionFlag() {
    this.$sessionStorage.store('redirectToResetPassword', 0);
  }

  loginWithToken(jwt, rememberMe) {
    if (jwt) {
      this.storeAuthenticationToken(jwt, rememberMe);
      return Promise.resolve(jwt);
    } else {
      return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
    }
  }

  storeAuthenticationToken(jwt, rememberMe) {
    if (rememberMe) {
      this.$localStorage.store('authenticationToken', jwt);
    } else {
      this.$sessionStorage.store('authenticationToken', jwt);
    }
  }

  isLoggedIn() {
    return this.getToken();
  }

  logout(): Observable<any> {
    return new Observable((observer) => {
      const app = (window as any)['dcWidgetApp'];
      if (app && typeof app.close === 'function') {
        app.close();
      }
      this.$localStorage.clear();
      this.$sessionStorage.clear();
      observer.complete();
    });
  }
}
